import { render, staticRenderFns } from "./StaffDetail.vue?vue&type=template&id=6f4f298c&scoped=true&lang=pug&"
import script from "./StaffDetail.vue?vue&type=script&lang=ts&"
export * from "./StaffDetail.vue?vue&type=script&lang=ts&"
import style0 from "./StaffDetail.vue?vue&type=style&index=0&id=6f4f298c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4f298c",
  null
  
)

export default component.exports